import React from 'react';
import { Icon, Tooltip } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export function ToggleInheritedInput({ rate, form, property, onChange = () => {} }) {
    const { t } = useTranslation();

    const isChecked = React.useMemo(() => {
        return Boolean(form?.[property]);
    }, [form, property]);

    const onLinkRateTemplate = React.useCallback(() => {
        let _form = {};
        _form[property] = null;
        let translations = { ...(form.translations || {}) };

        if (rate?.rate_template && translations[property]) {
            // Rate templates translations are not currently handled, so if a rate is re-linked to it's template
            // all of it's translations must be set to null to be erased.
            Object.keys(translations[property]).map(lng => {
                return (translations[property][lng] = '');
            });
        }
        _form.translations = translations;
        onChange(_form);
    }, [form, rate, onChange]);

    const _onChange = React.useCallback(() => {
        let _form = {};
        if (isChecked) {
            onLinkRateTemplate();
        } else {
            _form[property] = rate.rate_template[property];
            onChange(_form);
        }
    }, [isChecked, rate, onChange, property]);

    return (
        <div className="inherited-label-value-container">
            <Tooltip triggerOnHover title={<span>{form?.[property] ? t('ticket.rate_template.link_field_template') : t('ticket.rate_template.unlink_field_template')}</span>}>
                <Icon className="inherit-label-icon" name={isChecked ? 'unlink' : 'link'} onClick={_onChange} />
            </Tooltip>
        </div>
    );
}
